/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ConnectZaloUpdate = lazyLoad(
  () => import('./index'),
  module => module.ConnectZaloUpdate
);
